import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuard } from './app-routing-auth-guard';
import { RedirectGuard } from './app-routing-redirect-guard';
import { TrainingAppComponent } from './app.component';
import { AppPageComponent } from './chrome/app-page.component';



@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          pathMatch: 'full',
          redirectTo: 'home'
        },
        {
          path: 'home',
          component: TrainingAppComponent,
          pathMatch: 'full',
          canActivate: [AuthGuard],          
           runGuardsAndResolvers: 'always'
          
        },
        {
          path: 'training',
          component: AppPageComponent
          
        },
        {
          path: '**',
          redirectTo: 'home'
        }
      ],
      {
        onSameUrlNavigation: 'reload',
        scrollPositionRestoration: 'enabled',
      }
    )
  ],
  exports: [RouterModule],
 
})
export class AppRoutingModule {}
